import React, { createContext, ReactNode } from "react";
import { BrandConfig, Brand } from "banco/constants/generated/brand_config";

export const BrandConfigContext =
  createContext<BrandConfig>({} as BrandConfig);

type BrandConfigContextProps = {
  brand?: Brand,
  children: ReactNode
};

// eslint-disable-next-line max-statements
export const BrandConfigContextProvider = ({ brand, children }: BrandConfigContextProps) => {
  const value = brand ? BrandConfig.for(brand) : {} as BrandConfig;

  return (
    <BrandConfigContext.Provider value={ value }>
      { children }
    </BrandConfigContext.Provider>
  );
};

export const useBrandConfig = () => {
  return React.useContext(BrandConfigContext);
};
